export default function GetHelpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      style={{display:"block",height:"24px",width:"24px",fill:"currentColor"}}
      aria-hidden="true"
      role="presentation"
      focusable="false"
    >
      <path d="m16 .8.56.37C20.4 3.73 24.2 5 28 5h1v12.5C29 25.57 23.21 31 16 31S3 25.57 3 17.5V5h1c3.8 0 7.6-1.27 11.45-3.83L16 .8zm0 2.4-.34.2a22.58 22.58 0 0 1-10.3 3.55L5 6.97V17.5C5 24.33 9.72 28.86 15.71 29H16c6.13 0 11-4.56 11-11.5V6.97l-.35-.02a22.58 22.58 0 0 1-10.31-3.54L16 3.19zM20 8v4h4v8h-4v4h-8v-4H8v-8h4V8h8zm-2 2h-4v4h-4v4h4v4h4v-4h4v-4h-4v-4z"></path>
    </svg>
  );
}
